import React from 'react'
import "../../App.css";


export default function CV() {
  return <h1 className='cv'>CV</h1>;
}